import { Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ApiVisa, BaseApiTemplateService, Core2Config, Pagination, PagingResponseModel } from "../../shared";
import { WFDashboardReportResponseDto } from '../../../data-transfer-objects/wf/wf-dashboard-report-response-dto.model';

@Injectable({ providedIn: 'root' })
export class DashboardIssuesPerProjectReport extends BaseApiTemplateService<WFDashboardReportResponseDto> {
  constructor(theHttp: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.WF_PREFIX + 'dashboard/issue-per-project-report';
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX +  Core2Config.WF_PREFIX + 'dashboard/issue-per-project-report';
    this.httpClient = theHttp;
    }

    getIssuePerProjectReport(pagination: Pagination, visa: ApiVisa): Observable<PagingResponseModel<WFDashboardReportResponseDto>> {
      if (this.endpoint_path && visa.api_domain_url) {
        this.apiUrl = visa.api_domain_url + this.endpoint_path;
      }
      const UrlByCriteria = this.apiUrl + '?' + pagination.getQueryKeyValues();
      return this.httpClient.get<PagingResponseModel<WFDashboardReportResponseDto>>(
        UrlByCriteria,
        this.getHttpHeader(visa)
      );
    }
}
